export const filterBarPresetOptions = {
  all: {
    label: 'Ver todos',
    value: 's,r,c,a,l,u',
  },
  accredited: {
    label: 'Acreditación',
    value: 'a,c',
  },
  liquidated: {
    label: 'Liquidación',
    value: 'l',
  },
  transfers: {
    label: 'Transferencias',
    value: 'r,s',
  },
  adjustments: {
    label: 'Ajuste manual de saldo',
    value: 'u',
  }
}

export const movementTypeFilterPresets = [
  filterBarPresetOptions.all,
  filterBarPresetOptions.accredited,
  filterBarPresetOptions.liquidated,
  filterBarPresetOptions.transfers,
  filterBarPresetOptions.adjustments,
]
